import { FormControl, FormHelperText, InputLabel, Slider, styled } from '@mui/material';

import { type ClassSliderProps } from './types';

const StyledSlider = styled(Slider)`
    width: 75%;
    margin-left: 2rem;
    margin-top: 1rem;
`;

const Rows = styled('div')`
    display: flex;
    flex-direction: column;
`;

const StyledInputLabel = styled(InputLabel)`
    margin-bottom: 1rem;
    position: unset;
`;

const ControlledClassSlider = (props: ClassSliderProps) => {
    const { inputLabel, helperText, ...sliderProps } = props;
    return (
        <FormControl fullWidth>
            <StyledInputLabel htmlFor={props.id} id={`${props.id}-label`}>
                {inputLabel}
            </StyledInputLabel>
            {helperText && <FormHelperText id={`${props.id}-helper-text`}>{helperText}</FormHelperText>}
            <StyledSlider
                {...sliderProps}
                aria-labelledby={`${props.id}-label`}
                aria-describedby={helperText ? `${props.id}-helper-text` : undefined}
            />
        </FormControl>
    );
};
export default ControlledClassSlider;
